import UserDispatcherEditFormRequest from "../../../../api/raily/user/dispatcher/edit-form/user-dispatcher-edit-form.request";
import UserDispatcherEditFormParams from "./user-dispatcher-edit-form-params";

const create = (
  params: UserDispatcherEditFormParams,
): UserDispatcherEditFormRequest => {
  return {
    dispatcherId: params.dispatcherUuid,
  };
};

const userDispatcherEditFormParamsFactory = {
  create,
};

export default userDispatcherEditFormParamsFactory;
